// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var CustomInstrumentListTypeEnum;
(function (CustomInstrumentListTypeEnum) {
    CustomInstrumentListTypeEnum[CustomInstrumentListTypeEnum["None"] = -1] = "None";
    CustomInstrumentListTypeEnum[CustomInstrumentListTypeEnum["ThematicList"] = 0] = "ThematicList";
    CustomInstrumentListTypeEnum[CustomInstrumentListTypeEnum["SectorDefinition"] = 1] = "SectorDefinition";
    CustomInstrumentListTypeEnum[CustomInstrumentListTypeEnum["IndustryDefenition"] = 2] = "IndustryDefenition";
    CustomInstrumentListTypeEnum[CustomInstrumentListTypeEnum["MarketHeatMap"] = 3] = "MarketHeatMap";
    CustomInstrumentListTypeEnum[CustomInstrumentListTypeEnum["IndiciesChart"] = 4] = "IndiciesChart";
    CustomInstrumentListTypeEnum[CustomInstrumentListTypeEnum["DefaultList"] = 5] = "DefaultList";
    CustomInstrumentListTypeEnum[CustomInstrumentListTypeEnum["CustomList"] = 6] = "CustomList";
})(CustomInstrumentListTypeEnum || (CustomInstrumentListTypeEnum = {}));
